import { css, polished } from 'jimu-core';
export function formValidation(isValid, theme) {
    const stateColor = (theme === null || theme === void 0 ? void 0 : theme.sys)
        ? isValid ? theme.sys.color.success.main : theme.sys.color.error.main
        : isValid ? 'green' : 'red';
    return css `
    border-color: ${stateColor || (isValid ? 'green' : 'red')};
    ${!isValid && `background: ${polished.rgba(stateColor, 0.1)}`};
  `;
}
export function getInputHeight(inputVarsBySize, inputBorderWidth) {
    const heightInner = polished.math(`
    ${inputVarsBySize.fontSize} * ${inputVarsBySize.lineHeight} +
    ${inputVarsBySize.paddingY} * 2`);
    return inputBorderWidth.toString() === '0'
        ? heightInner
        : `calc(${heightInner} + ${inputBorderWidth} * 2)`;
}
function getInputSizingStyles(inputVars, size) {
    const inputVarsBySize = inputVars.sizes[size];
    return `
    height: ${inputVarsBySize.height !== 'auto'
        ? inputVarsBySize.height
        : getInputHeight(inputVarsBySize, inputVars.border.width)};
    padding: ${inputVarsBySize.paddingY} ${inputVarsBySize.paddingX};
    font-size: ${inputVarsBySize.fontSize};
    line-height: ${inputVarsBySize.lineHeight};
    border-radius: ${inputVarsBySize.borderRadius};
  `;
}
export const textInputStyles = (props) => {
    var _a;
    const size = props.bsSize || props.size;
    const theme = props.theme;
    const inputVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.input;
    return inputVars && css `
    &::-ms-expand {
      background-color: transparent;
      border: 0;
    }

    &.disabled .input-wrapper,
    &.readonly .input-wrapper {
      background: ${inputVars.disabled.bg};
      border-color: ${inputVars.disabled.borderColor};
      opacity: 1;
      color: ${inputVars.disabled.color};
      -webkit-text-fill-color: ${inputVars.disabled.color};
    }

    /* Form validation */
    &.is-invalid .input-wrapper {
      ${formValidation(false, theme)}
    }

    .error-msg {
      color: var(--sys-color-error-main);
    }

    &.no-border {
      .input-wrapper {
        border-color: transparent !important;
        &:focus-within {
          outline: 1px solid ${inputVars.focus.borderColor};
        }
        &:hover:not(:focus-within) {
          outline: 1px solid var(--ref-palette-neutral-700);
        }
      }
    }

    .input-wrapper {
      width: 100%;
      color: ${inputVars.color};
      background-color: ${inputVars.bg};
      background-clip: padding-box;
      border: ${inputVars.border.width} solid ${theme.sys.color.divider.input};
      box-shadow: ${inputVars.boxShadow};
      transition: ${inputVars.transition};
      outline-offset: -1px;
      ${!size && getInputSizingStyles(inputVars, 'default')}

      /* Form control sizing */

      ${size === 'sm' && getInputSizingStyles(inputVars, 'sm')}

      ${size === 'lg' && getInputSizingStyles(inputVars, 'lg')}

      &:focus-within {
        color: ${inputVars.focus.color};
        outline: 1px solid ${inputVars.focus.borderColor};
        /** !important is needed for the case dynamic-setting/title-input */
        background-color: ${inputVars.focus.bg} !important;
      }

      .text-input-clear{
        outline: none;
        padding: 0.125rem;
        &:focus .icon-btn-sizer {
          box-shadow: ${size === 'lg' ? '0px 0px 2px' : '0px 0px 3px 1px'} ${inputVars.focus.borderColor};
          border-radius: 10px;
          border: ${size === 'lg' ? `1px solid ${inputVars.focus.borderColor}` : 'none'};
        }
      }
    }
  `;
};
